module.exports = __webpack_public_path__ + "assets/img/enginio_header_desktop.79e6bd3f.png";